import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

//import { AuthenticationService } from '@/_services';

@Injectable({ providedIn: 'root' })
export class BraintreePaymentService  {

  public processingMapper: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {}

  notifyToDisableProcessing() {
    this.processingMapper.next(false);
  }

  notifyToEnableProcessing() {
    this.processingMapper.next(true);
  }

  getProcessingSubscription() {
    return this.processingMapper;
  }
}
